/**
 * Gender utility constants for the WeTree Web UI
 *
 * Note: The actual GenderType is imported from we-tree-api-client
 */

import { GenderType as GenderTypeObject, GenderType } from 'we-tree-api-client/v2';

// Extract values from the API client's GenderType object to ensure we stay in sync
export const GENDER_VALUES: readonly GenderType[] = Object.values(GenderTypeObject);

export const DEFAULT_GENDER: GenderType = 'unknown';

// Re-export the type for convenience
export type { GenderType };
